import OfficeOfficeHeader from './OfficeOfficeHeader';

export default OfficeOfficeHeader;
